let authorizationToken: string | null = null;

export const getAuthorizationToken = () => authorizationToken;

export const setAuthorizationToken = (token: string | null) => {
  authorizationToken = token;
};

export const resetAuthorizationToken = () => setAuthorizationToken(null);
